import React, { ChangeEventHandler, useMemo } from 'react'
import { ReceptorRecord } from '@trustero/trustero-api-web/lib/agent/receptor_pb'
import { StyledLabel } from '../../../Reusable/Inputs/TextInput/styles'
import {
  ReceptorFormInput,
  ReceptorFormErrorMsg,
} from './ActivateReceptorForm.styles'

export function TenantIdField({
  receptor,
  value,
  onChange,
  errorMsg,
}: {
  receptor: ReceptorRecord.AsObject
  value: string
  onChange: ChangeEventHandler<HTMLInputElement>
  errorMsg: string
}): JSX.Element {
  /**
   * Disable the input for existing receptors
   * - Meaning: Once the `tenantid` has been set, we do not allow any edits
   */
  const disableInput = useMemo(() => Boolean(receptor.tenantid), [receptor])
  const failedTenantId = useMemo(
    () => errorMsg === 'Account nickname already exists',
    [errorMsg],
  )
  const status = useMemo(
    () => (failedTenantId ? 'error' : 'default'),
    [failedTenantId],
  )

  return (
    <StyledLabel>
      <p>Nickname</p>
      <ReceptorFormInput
        required
        type="text"
        disabled={disableInput}
        name="tenant-id"
        value={value}
        placeholder="Nickname"
        onChange={onChange}
        status={status}
      />
      <ReceptorFormErrorMsg status={status}>
        {failedTenantId && errorMsg}
      </ReceptorFormErrorMsg>
    </StyledLabel>
  )
}
